import { render, staticRenderFns } from "./nav-bar-user-dropdown.vue?vue&type=template&id=010b98ad&"
import script from "./nav-bar-user-dropdown.vue?vue&type=script&lang=ts&"
export * from "./nav-bar-user-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports